module.exports = __webpack_public_path__ + "img/panel-logo.f860497c.png";